export const MESSAGE_SOURCE = 'aifindr-commerce-widget';

export const MESSAGE_TYPES = {
  INIT: 'aifindr:init',
  READY: 'aifindr:ready',
  EVENT: 'aifindr:event',
  ERROR: 'aifindr:error',
} as const;

export const EVENTS = {
  WIDGET_READY: 'widget.ready',
  WIDGET_ERROR: 'widget.error',
  CONVERSATION_STARTED: 'conversation.started',
  MESSAGE_SENT: 'message.sent',
  MESSAGE_RECEIVED: 'message.received',
  PRODUCT_SELECTED: 'commerce.product.selected',
  PRODUCT_CTA: 'commerce.product.cta',
} as const;

export type MessageType = typeof MESSAGE_TYPES[keyof typeof MESSAGE_TYPES];
export type WidgetEventName = typeof EVENTS[keyof typeof EVENTS];
